import { Component, EventEmitter, Input, OnInit, Output, ContentChild, TemplateRef, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { formatDateTimeZone } from 'src/app/shared/functions';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

export interface FilterItem {
    type: 'text' | 'date' | 'select' | 'custom' | 'date-range' | 'template';
    label?: string;
    placeholder?: string;
    formControlName?: string;
    icon?: string;
    // Options for select
    options?: any[];
    valueField?: string;
    labelField?: string;
    // Date range specific
    fromControlName?: string;
    toControlName?: string;
    // Custom template
    templateName?: string;
    class?: string;
}

export interface FilterConfig {
    items: FilterItem[];
    showAdvanced?: boolean;
    advancedItems?: FilterItem[];
    customTemplates?: { [key: string]: TemplateRef<any> };
}

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
    @Input() formGroup!: FormGroup;
    @Input() config!: FilterConfig;
    @Input() loading = false;
    @Input() showExport = false;
    @Input() showAdvancedToggle = false;

    @Output() search = new EventEmitter<void>();
    @Output() export = new EventEmitter<void>();
    @Output() advancedToggle = new EventEmitter<boolean>();

    showAdvanced = false;

    @ContentChild('customTemplate') customTemplate!: TemplateRef<any>;
    customTemplates: { [key: string]: TemplateRef<any> } = {};

    constructor() { }

    ngOnInit(): void {
    }

    toggleAdvanced() {
        this.showAdvanced = !this.showAdvanced;
        this.advancedToggle.emit(this.showAdvanced);
    }

    onSearch() {
        this.search.emit();
    }

    onExport() {
        this.export.emit();
    }

    // Date helpers
    removeValue(controlName: string) {
        this.formGroup.get(controlName)?.setValue(null);
    }

    /**
     * Parse date value to ensure it is a native Date object (local date)
     */
    parseLocalDate(value: any): Date | null {
        if (!value) return null;
        if (value instanceof Date) return value;
        const m = moment(value);
        return m.isValid() ? m.toDate() : null;
    }

    /**
     * Handle date change from mat-datepicker
     */
    onDateChange(controlName: string, value: any) {
        if (value) {
            const localDate = this.parseLocalDate(value);
            this.formGroup.get(controlName)?.setValue(localDate, { emitEvent: true });
        }
    }
}
